import i from "react";
import n from "prop-types";
import u from "classnames";
import { N as _ } from "./NoClickOutline-CllwvnB9.es.js";
import { u as r } from "./ThemeProvider--i7ESlT5.es.js";
import './CalendarUnitButton.css';const s = "CalendarUnitButton-compere-module__row___UUYpX", m = "CalendarUnitButton-compere-module__blankDay___esyZ9", c = "CalendarUnitButton-compere-module__dayButton___irzTT", h = "CalendarUnitButton-compere-module__startPoint___qrAQd", g = "CalendarUnitButton-compere-module__endPoint___dD-Gv", B = "CalendarUnitButton-compere-module__monthButton___tho-v", f = "CalendarUnitButton-compere-module__rangeMode___04sgd", C = "CalendarUnitButton-compere-module__highlight___2UmUM", y = {
  row: s,
  blankDay: m,
  dayButton: c,
  startPoint: h,
  endPoint: g,
  monthButton: B,
  rangeMode: f,
  highlight: C
}, P = "CalendarUnitButton-default-module__row___DoEdT", M = "CalendarUnitButton-default-module__blankDay___xaS9i", U = "CalendarUnitButton-default-module__dayButton___btcpX", b = "CalendarUnitButton-default-module__startPoint___D-1MF", k = "CalendarUnitButton-default-module__endPoint___pnt6-", O = "CalendarUnitButton-default-module__monthButton___f35bL", D = "CalendarUnitButton-default-module__rangeMode___7ARgO", $ = "CalendarUnitButton-default-module__highlight___W3VOk", e = {
  row: P,
  blankDay: M,
  dayButton: U,
  startPoint: b,
  endPoint: k,
  monthButton: O,
  rangeMode: D,
  highlight: $
}, v = {
  compere: y,
  default: e
}, a = (t) => {
  const d = r(), o = v[d] || e, l = t.rangeMode ? "button" : _.Button;
  return /* @__PURE__ */ i.createElement(
    l,
    {
      className: u(
        t.unit === "day" ? o.dayButton : o.monthButton,
        t.highlight && o.highlight,
        t.endPoint && o.endPoint,
        t.startPoint && o.startPoint,
        t.rangeMode && o.rangeMode
      ),
      onMouseOut: t.onMouseOut,
      onMouseOver: t.onMouseOver,
      onClick: t.onClick,
      tabIndex: t.rangeMode ? -1 : 0,
      disabled: t.disabled
    },
    t.text
  );
};
a.propTypes = {
  text: n.string.isRequired,
  disabled: n.bool,
  highlight: n.bool,
  endPoint: n.bool,
  startPoint: n.bool,
  onClick: n.func,
  onMouseOver: n.func,
  onMouseOut: n.func.isRequired,
  unit: n.oneOf(["month", "day"]).isRequired,
  rangeMode: n.bool.isRequired
};
a.defaultProps = {
  disabled: !1,
  highlight: !1,
  endPoint: !1,
  startPoint: !1,
  onClick: () => {
  },
  onMouseOver: () => {
  }
};
export {
  a as C
};
